export default __webpack_public_path__ + "static/media/rectangle_white_list.06bbe988.svg";